import React, { useMemo } from "react";

function SourceImage({ projectID, src, srcMode, onClick }) {
  const imgsrc = useMemo(() => {
    if (srcMode === "cdn") {
      if (src?.og) {
        return `https://cdn.grigora.co/projects/${
          src?.projectID ? src.projectID : projectID
        }/${src?.og}`;
      }
      return `https://cdn.grigora.co/projects/${
        src?.projectID ? src.projectID : projectID
      }/${src?.name}.${src?.extension}`;
    } else if (srcMode === "link") {
      return src;
    } /* only in editor */ else if (srcMode === "preview") {
      return src;
    }
    return undefined;
  }, [srcMode, src]);

  return (
    <div onClick={onClick} className="relative">
      {/* <div className="absolute flex top-0 bottom-0 left-0 right-0 justify-center items-center duration-300 hover:bg-white hover:bg-opacity-10 hover:backdrop-blur-sm">
            <FontAwesomeIcon icon={faEdit} />
          </div> */}
      <img src={imgsrc} />
    </div>
  );
}

export default SourceImage;
